module.exports = __webpack_public_path__ + "static/img/km.9b06043d.svg";